import styled, { css } from 'styled-components';
import { Button } from '@aon-coverwallet/cw-react-components';

export const StyledPrimaryButton = styled(Button)(
  ({ theme, secondaryColor }) => {
    return css`
      font-weight: 400;

      p {
        margin-bottom: 0;
      }

      ${secondaryColor &&
      `
        border: 1px solid ${theme.colors.brand.secondary.default};
        color: ${theme.colors.white};
        background-color: ${theme.colors.brand.secondary.default};
      `}

      :hover {
        color: ${theme.colors.white};
        background-color: ${theme.colors.gray.normal};
        border: 1px solid ${theme.colors.gray.normal};
      }
    `;
  },
);

export const StyledSecondaryButton = styled(Button)(
  ({ theme, secondaryColor }) => {
    return css`
      font-weight: 400;

      p {
        margin-bottom: 0;
      }

      ${secondaryColor &&
      `
        border: 1px solid ${theme.colors.brand.secondary.default};
        color: ${theme.colors.brand.secondary.default};
        background-color: ${theme.colors.white};
      `}

      :hover {
        color: ${theme.colors.white};
        background-color: ${theme.colors.gray.normal};
        border: 1px solid ${theme.colors.gray.normal};
      }
    `;
  },
);

export const StyledTertiaryButton = styled(Button)(({ theme }) => {
  return css`
    font-weight: 100;

    p {
      margin-bottom: 0;
    }

    svg {
      height: 20px;
      width: 20px;
    }

    :hover {
      border: none;
      background: none;
      color: ${theme.colors.gray.normal};

      svg path:first-child {
        fill: ${theme.colors.gray.normal};
      }
    }
  `;
});

export const HiddenButton = styled.button`
  display: none;
`;
